import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { UtilisateurResponse } from '../../../model/response/UtilisateurResponse';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OneUtilisateurResponse } from '../../../model/response/OneUtilisateurResponse';
import { Utilisateur } from '../../../model/Utilisateur';
import { ResetPasswordDto } from '../../../model/dto/ResetPasswordDto';
import { TableReservationDto } from '../../../model/TableReservationDto';
import { AccessPermissions } from '../../../model/AccessPermissions';
import { EnvironmentService } from '../../environnement.service';

@Injectable({
  providedIn: 'root'
})
export class UtilisateurEndPointService {

  constructor(private environmentService: EnvironmentService, private httpclient: HttpClient) { }

  header = new HttpHeaders(
    {
      'Access-Control-Allow-Origin': '*',
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT'
    }
  );

  CreateUtilisateur(user: Utilisateur) {
    return this.httpclient.post<OneUtilisateurResponse>(this.environmentService.backend_url_Admin + "CreateUtilisateur", user, { headers: this.header });
  }

  Editpaaswor(resetPasswordDto: ResetPasswordDto) {
    return this.httpclient.post<OneUtilisateurResponse>(this.environmentService.backend_url_Admin + "Editpaaswor", resetPasswordDto, { headers: this.header });

  }
  findUtilisateurByIdUtilisateur(id: string) {
    return this.httpclient.get<OneUtilisateurResponse>(this.environmentService.backend_url_Admin + "findUtilisateurByIdUtilisateur/" + id, { headers: this.header });
  }

  findAllByIdPointVente(idPointVente: string) {
    return this.httpclient.get<UtilisateurResponse>(this.environmentService.backend_url_Admin + "findAllByIdPointVente/" + idPointVente, { headers: this.header });
  }

  DeleteUtilisateur(idUtilisateur: string) {
    return this.httpclient.delete<any>(this.environmentService.backend_url_Admin + "DeleteUtilisateur/" + idUtilisateur, { headers: this.header });
  }

  findfreeemplyeebyreservation(tableReservationDto: TableReservationDto) {
    return this.httpclient.post<UtilisateurResponse>(this.environmentService.backend_url_Admin + "findfreeemplyeebyreservation", tableReservationDto, { headers: this.header });
  }
  UpdateUtilisateur(user: Utilisateur) {
    return this.httpclient.put<OneUtilisateurResponse>(this.environmentService.backend_url_Admin + "UpdateUtilisateur", user, { headers: this.header });
  }

  updateaccesspermissions(userId: string, accessPermissions: AccessPermissions) {
    return this.httpclient.put<any>(this.environmentService.backend_url_Admin + "updateaccesspermissions/" + userId,
      accessPermissions, { headers: this.header });
  }
}
